export default {"src":"/_next/static/media/mobile_fabrication.8de128c6.gif","height":300,"width":480,"blurWidth":0,"blurHeight":0};